import api from "../../../../services/api";

import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import * as globalComponents from "../../../../components";

import "../../styles.css";

export default function EstablishmentOrientationsScene() {
  const { accessType, establishmentOrientationID } = useParams();

  const dir = [
    {
      title: "Serviços Online",
      url: `/${accessType}/servicos-online`,
    },
    {
      title: "Orientações para Empresas e Consultórios",
      url: `/${accessType}/servicos-online/orientacoes-empresas-e-consultorios`,
    },
  ];

  const [data, setData] = useState({
    Titulo: null,
    Subtitulo: null,
    Chamada: null,
    Data_Publicacao: null,
    Nome_Arquivo: null,
    Materia: null,
  });

  useEffect(() => {
    window.scroll(0, 0);
    async function fetchData() {
      await api
        .get(`/conteudo/${establishmentOrientationID.split("_").pop()}`)
        .then((response) => {
          setData(response.data);
        })
        .catch((err) => {
          console.log(err);
        });
    }
    fetchData();
  }, [establishmentOrientationID]);

  return (
    <>
      <globalComponents.Header />

      <globalComponents.Breadcrumbs title="Orientação" dir={dir} />

      <div className="container">
        <div className="content-wrapper">
          <globalComponents.PageTitle
            title={data.Titulo}
            subtitle={data.Subtitulo}
            span={data.Data_Publicacao}
          />

          <div
            className="content-text"
            dangerouslySetInnerHTML={{ __html: data.Materia }}
          ></div>
        </div>
      </div>

      <globalComponents.Footer />
    </>
  );
}
